// extracted by mini-css-extract-plugin
module.exports = {"container":"Avatar_container__fQpf4","avatar":"Avatar_avatar__33rUO","uploadButton":"Avatar_uploadButton__3Jsa_","withBorder":"Avatar_withBorder__3_p0W"};